import { render } from "./ContactButton.vue?vue&type=template&id=8a069252&scoped=true"
import script from "./ContactButton.vue?vue&type=script&lang=js"
export * from "./ContactButton.vue?vue&type=script&lang=js"

import "./ContactButton.vue?vue&type=style&index=0&id=8a069252&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a069252"]])

export default __exports__